import React from 'react'
import {Selection, SelectionDefaults} from '../../inputs';
const list = ['Initials','Signature','Date','Textbox','Checkbox']

export default function Assignment(props) {
  const { onChange, assignment } = props
  return (
    <Selection list={list} onChange={onChange} selected={assignment} label={'Assignment'} orientation={'row'} margins={SelectionDefaults.margins} buttonsMargins={SelectionDefaults.buttonsMargins}/>
  )
}